import { lazy } from "react";

export const Home = lazy(()=>import("./home/Home").then((module)=>({default:module.Home})))
export const RecordedSessions = lazy(()=>import("./recordedSessions/RecordedSessions").then((module)=>({default:module.RecordedSessions})))
export const Events = lazy(()=>import("./events/Events").then((module)=>({default:module.Events})))
export const Quizzes = lazy(()=>import("./quizzes/Quizzes").then((module)=>({default:module.Quizzes})))
export const Module = lazy(()=>import("./module/Module").then((module)=>({default:module.Module})))
export const Support = lazy(()=>import("./support/Support").then((module)=>({default:module.Support})))
export const Quiz = lazy(()=>import("./quiz/Quiz").then((module)=>({default:module.Quiz})))
export const SessionVideo = lazy(()=>import("./sessionVideo/SessionVideo").then((module)=>({default:module.SessionVideo})))
export const Signup = lazy(()=>import("./signup/Signup").then((module)=>({default:module.Signup})))
